var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPst = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9e16",
  d: "m11.914 12.546 4.813-8.277a9.05 9.05 0 0 0-4.814-1.27z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.21 6.514h-.305v7.127h.306z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.646 6.255h.823V13.9h-.823z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m14.693 7.148-3.569 6.172.265.152L14.957 7.3z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m10.77 13.415 3.828-6.62.713.41-3.828 6.62z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.212 2.996h-.309V5.12h.309z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.645 2.737h.826V5.38h-.826z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m7.656 4.148-.267.154 1.064 1.84.267-.155z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m7.036 4.207.715-.413 1.323 2.288-.716.413z",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m4.287 7.419-.154.267 1.843 1.062.154-.267z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m3.78 7.78.413-.715 2.29 1.321-.413.715z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M5.135 11.935H3.008v.308h2.127z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M2.75 11.676h2.644v.826H2.75z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M6.004 15.422 4.16 16.484l.155.267 1.842-1.062z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m3.807 16.39 2.291-1.322.414.715-2.291 1.321z",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m8.502 18.01-1.064 1.839.267.154 1.064-1.84z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m7.084 19.943 1.323-2.287.716.412L7.8 20.356z",
  clipRule: "evenodd"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M12.268 19.002h-.309v2.124h.309z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M11.7 18.743h.827v2.642H11.7z",
  clipRule: "evenodd"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m15.72 17.981-.267.154 1.063 1.84.267-.154z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m15.099 18.04.715-.412 1.323 2.288-.716.412z",
  clipRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m18.197 15.373-.154.267 1.842 1.062.155-.267z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m17.689 15.735.413-.715 2.292 1.32-.414.716z",
  clipRule: "evenodd"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "M21.164 11.879h-2.127v.308h2.127z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M18.778 11.62h2.645v.826h-2.645z",
  clipRule: "evenodd"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m19.858 7.371-1.843 1.063.154.267 1.843-1.063z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m17.661 8.339 2.291-1.321.414.715-2.291 1.321z",
  clipRule: "evenodd"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  d: "m16.467 4.12-1.064 1.84.268.154 1.063-1.84z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "m15.05 6.054 1.322-2.287.716.412-1.323 2.288z",
  clipRule: "evenodd"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#1b3e6f",
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0 1c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11",
  clipRule: "evenodd"
})));
export default SvgPst;